export const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    square: {
        marginRight: '1rem',
        width: '1.2rem',
        height: '1.2rem',
    },
    row_info: {
        display: 'flex',
        marginTop: '1.5rem',
        [theme.breakpoints.only('sm')]: {
            fontSize: '1.2rem'
        }
    },
    flex_container: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    paper: {
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        height: '100%',
        boxSizing: 'border-box',
        display: 'flex'
    },
    paperLeft: {
        marginLeft: '4rem',
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
        }
    },
    paperRight: {
        marginRight: '4rem',
        [theme.breakpoints.down('md')]: {
            marginRight: 0,
        }
    },
    containerLeft: {
        paddingRight: 40,
        [theme.breakpoints.only('md')]: {
            paddingRight: 15,
        },
        [theme.breakpoints.only('sm')]: {
            paddingRight: 0,
            marginBottom: 20
        }
    },
    labelChart: {
        height: '100%'
    },
    titleChart:{
        fontSize: '1rem',
        fontWeight: 500,
        color: '#000000',
        [theme.breakpoints.only('sm')]: {
            fontSize: '1.2rem',
            textAlign: 'center'
        }
    },
    text:{
        [theme.breakpoints.up('lg')]: {
            fontSize: 16
        },  
        [theme.breakpoints.only('md')]: {
            fontSize: 16
        },
        [theme.breakpoints.only('sm')]: {
            fontSize: 16
        },
        textTranform: 'capitalize'
    }

});